import React, { useEffect, useState } from 'react'
import { ScaleLinear, scaleLinear } from 'd3-scale'
import './styles.scss'
import { formatSwissDate } from 'components/Charts_Assets'
import { Slider, Handles, Tracks, Rail, Ticks } from 'react-compound-slider'
const isMobile = window.innerWidth < 600
export const DateSlider = ({
  selectedRange,
  range,
  selectRange,
  id
}: {
  range: Date[]
  selectedRange: Date[]
  selectRange: (e: Date[], i: number) => void
  id: number
}) => {
  const timeScale = scaleLinear<Date, Date>()
    .domain([0, 100])
    .range(range)

  const convertRangeToNumbers = (a: Date[]) => a.map(m => timeScale.invert(m))

  const convertRangeToDates = (a: readonly number[]) =>
    a.map(m => new Date(timeScale(m) || new Date()))

  // useEffect(() => {

  //   setInternalRange(convertRangeToNumbers(selectedRange))
  // }, [selectedRange])

  return (
    <div className={'DateSlider ' + (id === 111 ? 'noChart' : '')}>
      {selectedRange && (
        <Slider
          domain={[0, 100]}
          values={convertRangeToNumbers(selectedRange)}
          mode={2}
          className='wrapper'
          onUpdate={(a: readonly number[]) => {
            selectRange(convertRangeToDates(a), id)
          }}
        >
          {/* {isMobile && (
            <div className={'rangetop '}>
              {formatSwissDate(
                new Date(selectedRange[0]).toISOString().split('T')[0]
              )}{' '}
              –{' '}
              {formatSwissDate(
                new Date(selectedRange[1]).toISOString().split('T')[0]
              )}
            </div>
          )} */}
          <Rail>
            {({ getRailProps }) => <div className='rail' {...getRailProps()} />}
          </Rail>
          <Handles>
            {({ handles, getHandleProps }) => (
              <div className='slider-handles'>
                {handles.map(handle => (
                  <Handle
                    show={id === 111}
                    timeScale={timeScale}
                    key={handle.id}
                    handle={handle}
                    getHandleProps={getHandleProps}
                  />
                ))}
              </div>
            )}
          </Handles>
          <Tracks left={false} right={false}>
            {({ tracks, getTrackProps }) => (
              <div className='slider-tracks'>
                {tracks.map(({ id, source, target }) => (
                  <Track
                    range={selectedRange}
                    key={id}
                    source={source}
                    target={target}
                    getTrackProps={getTrackProps}
                  />
                ))}
              </div>
            )}
          </Tracks>
          <Tracks left={false} right={false}>
            {({ tracks, getTrackProps }) => <div></div>}
          </Tracks>
        </Slider>
      )}
    </div>
  )
}
function Handle({
  show = false,
  timeScale,
  handle: { id, value, percent },
  getHandleProps
}: {
  show?: boolean
  timeScale: ScaleLinear<Date, Date>
  handle: { id: string; value: number; percent: number }
  getHandleProps: (props) => void
}) {
  return (
    <button
      className={
        'handle ' +
        (percent > 80 ? 'align_right' : percent < 20 ? 'align_left' : '')
      }
      style={{
        left: `${percent}%`
      }}
      {...getHandleProps(id)}
    >
      {show && (
        <div className={'value ' + (+id.substr(3) === 0 ? 'left' : 'right')}>
          {formatSwissDate(
            new Date(timeScale(value) || new Date()).toISOString().split('T')[0]
          )}
        </div>
      )}
    </button>
  )
}

function Track({ source, target, getTrackProps, range }) {
  return (
    <div
      className='track'
      style={{
        left: `${source.percent}%`,
        width: `${target.percent - source.percent}%`
      }}
    >
      {!isMobile && (
        <div
          className={
            'range ' +
            (source.percent > 70 && target.percent > 70
              ? 'right'
              : source.percent < 30 && target.percent < 30
              ? 'left'
              : '')
          }
        >
          {/* {formatSwissDate(new Date(range[0]).toISOString().split('T')[0])} –{' '}
          {formatSwissDate(new Date(range[1]).toISOString().split('T')[0])} */}
        </div>
      )}
    </div>
  )
}
